/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Lévy distribution quantile function.
*
* @module @stdlib/stats/base/dists/levy/quantile
*
* @example
* import quantile from '@stdlib/stats/base/dists/levy/quantile';
*
* var y = quantile( 0.8, 0.0, 1.0 );
* // returns ~15.580
*
* @example
* import { factory as factory } from '@stdlib/stats/base/dists/levy/quantile';
* var quantile = factory( 10.0, 2.0 );
*
* var y = quantile( 0.5 );
* // returns ~14.396
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import factory from './factory.js';


// MAIN //

setReadOnly( main, 'factory', factory );


// EXPORTS //

export default main;
